import Vue from 'vue';
import Rollbar from 'vue-rollbar';

if (process.env.NODE_ENV === 'production' || process.env.NODE_ENV === '') {
  Vue.use(Rollbar, {
    accessToken: '784f7d0b7dc2419f979c9b9c972bd078',
    captureUncaught: true,
    captureUnhandledRejections: true,
    enabled: true,
    source_map_enabled: true,
    environment: 'production',
    payload: { client: { javascript: { code_version: '1.0' } } },
  });
}
